import { call, put, select } from 'redux-saga/effects';

import { setContracts } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* createContract() {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/contracts/template?name=payasyougo`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.POST,
  });
  if (!error && success) {
    yield put(setContracts({ ...result }));
  }
}
